import {GameDetailsContainerDefaultBox} from './game-details-container.default.box';
import {styledByTheme} from '../../../../../themes/architecture/styled-by-theme';
import {GameDetailsContainerCasino777Box} from './game-details-container.casino777.box';

export const GameDetailsContainerBox: any = styledByTheme(GameDetailsContainerDefaultBox).forCasino777(GameDetailsContainerCasino777Box).apply();